/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";
import LockIcon from "@material-ui/icons/Lock";
import { useI18n } from "hooks/i18n/i18n";
import React from "react";

export const EventTicketUnavailableForPurchaseOverlay: React.FC<{
  isLottery: boolean;
}> = ({ isLottery }) => {
  const { t } = useI18n();
  const titleLine2 = isLottery
    ? t("event.ticket.unavailableForPurchase.titleLine2ForLottery")
    : t("event.ticket.unavailableForPurchase.titleLine2");

  return (
    <div css={root}>
      <div css={header}>
        <LockIcon css={icon} aria-hidden="true" />
        <p css={headerText}>
          {t("event.ticket.unavailableForPurchase.titleLine1")}
          <br />
          {titleLine2}
        </p>
      </div>

      <p css={caption}>{t("event.ticket.unavailableForPurchase.caption")}</p>
    </div>
  );
};

const root = css({
  position: "absolute",
  top: 0,
  left: 0,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: "4px",
  width: "100%",
  height: "100%",
  padding: "32px 48px",
  color: "#fff",
  backgroundColor: "rgba(0, 0, 0, 0.5)",
});

const header = css({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "center",
  gap: "8px",
});

const icon = css({
  "&.MuiSvgIcon-root": {
    width: "40px",
    height: "40px",
  },
});

const headerText = css({
  fontSize: "18px",
  fontWeight: "700",
  lineHeight: "1.2",
});

const caption = css({
  fontSize: "12px",
  lineHeight: "1.5",
});
